import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, SvgIcon, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import moment from 'moment-timezone';
import classNames from 'classnames';
import messages from 'common/messages/messages';
import { ReactComponent as LogoIcon } from 'img/PeakLogoSmall.svg';
import { Routes } from 'constants/route.constants';
import useSidebarContext from 'common/hooks/context/useSidebarContext';

const useStyles = makeStyles(() => ({
  sidebarFooter: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  policyLinks: {
    display: 'inline-flex',
    flexDirection: 'column',
    gap: '6px',
  },
  policyLink: {
    fontSize: '12px',
    fontWeight: 700,
    '&:hover': {
      color: 'white',
    },
  },
  companyInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& p': {
      fontSize: '12px',
      fontWeight: 400,
    },
  },
  companyInfoClosed: {
    justifyContent: 'center',
  },
  companyLogo: {
    height: 30,
    width: 31,
  },
}));

const SidebarFooter: FC = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { sidebarOpen } = useSidebarContext();

  return (
    <div className={classes.sidebarFooter}>
      {sidebarOpen ? (
        <div className={classes.policyLinks}>
          <Link to={Routes.PRIVACY_POLICY} className="no-wrap">
            <Typography color="secondary" className={classes.policyLink}>
              {intl.formatMessage(messages.privacyPolicy)}
            </Typography>
          </Link>

          <Link to={Routes.COOKIE_POLICY} className="no-wrap">
            <Typography color="secondary" className={classes.policyLink}>
              {intl.formatMessage(messages.cookiePolicy)}
            </Typography>
          </Link>

          <Link to={Routes.TERMS_OF_SERVICE} className="no-wrap">
            <Typography color="secondary" className={classes.policyLink}>
              {intl.formatMessage(messages.termsOfService)}
            </Typography>
          </Link>
        </div>
      ) : null}

      <div
        className={classNames(classes.companyInfo, {
          [classes.companyInfoClosed]: !sidebarOpen,
        })}
      >
        {sidebarOpen ? (
          <Typography color="secondary" className="no-wrap">
            {intl.formatMessage(messages.sidebarFooterText, {
              year: moment().format('YYYY'),
              br: <br />,
            })}
          </Typography>
        ) : null}

        <SvgIcon viewBox="0 0 31 30" className={classes.companyLogo} component={LogoIcon} />
      </div>
    </div>
  );
};

export default SidebarFooter;
